import { DatedList, Icon } from 'gu-ui-kit'
import qs from 'qs'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import prepareFilterParams from 'utils/prepareFilterParams'
import { useWallets } from 'modules/Finance/Wallets'
import EmptyResults from 'components/EmptyResults'
import formatRelative from 'utils/dateFns/formatRelative'
import TransactionRow from './subcomponents/TransactionRow'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import FilterPanel from 'components/Filters/FilterPanel'
import useFiltersManager from 'utils/hooks/useFiltersManager'
import config from 'modules/Finance/Wallets/config/filters'
import { SET_WALLETS_FILTERS } from 'modules/Finance/Wallets/store/types'
import styles from 'modules/Finance/Wallets/subcomponents/Transaction/Transaction.module.scss'

const Transaction = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const {
    transactions: { data: transactions = [], pagination = {}, loaded, failed, loading } = {},
    activeWalletID,
    filters,
  } = useSelector((state) => state['finance/wallets'])

  const filterManager = useFiltersManager({
    filters: filters,
    config: config(),
    setAction: SET_WALLETS_FILTERS,
  })

  const { getWalletTransactions, resetTransactions } = useWallets()

  useEffect(() => {
    if (!activeWalletID || !filterManager.filters) {
      return
    }

    resetTransactions()
  }, [filterManager.filters, activeWalletID])

  useEffect(() => {
    if (!activeWalletID || !filterManager.filters) {
      return null
    }

    const { limit = 8 } = pagination

    getWalletTransactions({
      id: activeWalletID,
      offset: (page - 1) * limit,
      ...prepareFilterParams(filterManager.filters),
    })
  }, [activeWalletID, page, filterManager.filters])

  const downloadLink = useMemo(() => {
    if (activeWalletID === null) {
      return null
    }
    const { name = '', ...rest } = prepareFilterParams(filters)
    const params = qs.stringify(
      { search: name, ...rest },
      {
        arrayFormat: 'brackets',
      },
    )
    return `/api/app/v1/wallets/${activeWalletID}/transactions-export?${params}`
  }, [activeWalletID, filters])

  return (
    <>
      <FilterPanel
        filterManager={filterManager}
        className={clsx(styles['wallets__filter-panel'], 'margin-bottom-32')}
      />
      <div className={styles['transaction']}>
        <DatedList
          emptyComponent={
            <EmptyResults
              header={t('common::empty_results.header')}
              className={styles['transaction-empty']}
              icon={<Icon name={'business-cards'} />}
              text={t('common::empty_results.text')}
            />
          }
          itemComponent={TransactionRow}
          pagination={pagination}
          items={transactions.map(({ created_at, ...rest }) => ({
            ...rest,
            date: created_at * 1000,
          }))}
          moreButtonLabel={t('wallets::transaction.showMore')}
          handleGetMoreItems={() => setPage((page) => page + 1)}
          loading={loading}
          loaded={loaded}
          loadFailed={failed}
          downloadButton={{ label: t('wallets::transaction.download'), url: downloadLink }}
          l10n={{
            formatFunction: formatRelative,
            today: t('common::dated_list.date_format.today'),
            yesterday: t('common::dated_list.date_format.yesterday'),
            formatDates: {
              short: t('common::dated_list.date_format.short'),
              long: t('common::dated_list.date_format.long'),
            },
          }}
        />
      </div>
    </>
  )
}
Transaction.propTypes = {}

export default Transaction
